export default __webpack_public_path__ + "static/media/img-0142-india-full-face.b0d682d8.png";